export default "__VITE_ASSET__Be73wVDL__"